import React from 'react'
import MostyLogo from '../assets/images/logo_mosty_colored.svg'
import { FiHome } from 'react-icons/fi'
import { useHistory } from 'react-router-dom'
import text from '../constants/Menu'
import '../styles/components/Header.css'

const Header = ({ language }) => {
  const history = useHistory()

  return (
    <div className='header-container'>
      <img src={MostyLogo} alt='logo' />
      <button onClick={() => history.push('/')}
        className='header-container-home-button'>
        <FiHome size={20} color='var(--dark-gray)' />
        <p>{text.home[language]}</p>
      </button>
    </div>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js